import { apiSlice } from "../../app/api/apiSlice";

// SuperAdmin document action-log (Admin Zentrale). The list endpoint is
// cross-tenant and server-side paginated/filtered; the history endpoint reuses
// the existing per-document trail.
export const actionLogApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDocumentActionLogs: builder.query({
      // params: { page, limit, action, result, q, from, to, tenant, fileId }
      query: (params = {}) => ({
        url: "/filedata/action-logs",
        params,
      }),
      keepUnusedDataFor: 5,
    }),
    getDocumentActionHistory: builder.query({
      query: (fileId) => `/filedata/${fileId}/history`,
      keepUnusedDataFor: 5,
    }),
  }),
});

export const {
  useGetDocumentActionLogsQuery,
  useGetDocumentActionHistoryQuery,
} = actionLogApiSlice;
